<span
  [ngStyle]="{'background-color': color}"
  role=img
  [attr.alt]="fullName"
  title="{{fullName}}"
  attr.aria-label="{{fullName}}"
  class="bubble">{{initials}}
</span>
